import { Button, Grid } from '@mui/material';
import { useState } from 'react';
import styled from 'styled-components';
import { HypoListModal } from './hypo-list-modal';

export const HypoglycemiaReadings = (props) => {
  const { getCustomDateList, disableGetListDataBtn } = props;
  const [modalViewHypoOpen, setModalViewHypoOpen] = useState(false);
  const HypoReadingHandler = () => {
    setModalViewHypoOpen(true);
    getCustomDateList();
  };

  return (
    <StyledHypoglycemiaReadings className="hypo-reading_container">
      <Button
        disabled={disableGetListDataBtn}
        onClick={HypoReadingHandler}
        className=" hypo-reading_button "
      >
        View Hypoglycemia Readings
      </Button>
      <HypoListModal
        open={modalViewHypoOpen}
        setOpen={setModalViewHypoOpen}
        {...props}
      />
    </StyledHypoglycemiaReadings>
  );
};

const StyledHypoglycemiaReadings = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 0 28px;
  background-color: #f4f4f4;

  .hypo-reading_button {
    height: 32px;
    border: 1px solid #ffffff;
    box-shadow: 1px 1px 2px 0 #00000029;
    border-radius: 50px;
    font-size: 14px;
    font-family: 'dana-bold';
    padding: 12px 16px 6px 16px;
    text-transform: none;
  }
  @media screen and (min-width: 1024px) {
    background-color: transparent;
    padding: 0 0 60px;
    .hypo-reading_button {
      background: #f5f5f5;
      font-size: 20px;
      border-radius: 24px;
      height: 60px;
    }
  }
`;
